import React from 'react';

let Quote = require('../Managers/Quote');

const GlobalHeader = React.createClass({
    propTypes: {
        isSummary: React.PropTypes.bool,
    },

    getDefaultProps() {
        return {
            isSummary: false,
        };
    },

    getInitialState() {
        return {
            quote: Quote.getQuote(),
            isHeaderPriceVisible: false,
        };
    },

    componentDidMount() {
        $('#firstname').val(localStorage.getItem("first_name"));
        $('#lastname').val(localStorage.getItem("last_name"));
        $('#email').val(localStorage.getItem("email_address"));
        $('#contact').val(localStorage.getItem("phone_number"));
        window.addEventListener('scroll', this.handleScroll);
    },

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    },

    updateQuoteState : function(_quote) {
        this.setState({
            quote : _quote
        });
    },

    handleScroll(e) {
        let scrollTop = e.target.body.scrollTop;
        let scrollTopFF = e.target.documentElement.scrollTop;
        if (this.props.isSummary === true) {
            if (this.state.quote == undefined || this.state.quote == null) {
                return false;
            }

            if ((scrollTop > 300 || scrollTopFF > 300) && this.state.quote.premiums.annual.formatted.gross_inc_ipt_and_fee) {
                this.setState({isHeaderPriceVisible: true});
            } else {
                this.setState({isHeaderPriceVisible: false});
            }
        }
    },

    render() {
        return (
            <header className="site-header">
                <div className="branding">
                    <a href="https://homelet.co.uk/landlord-insurance" title="Landlord Insurance+ | HomeLet" target="_blank">
                        <img className="logo big" src="/images/homelet-logo.svg" alt="HomeLet logo" />
                        <img className="logo small" aria-hidden="true" src="/images/homelet-logo-small.svg" alt="HomeLet logo" />
                    </a>

                    {this.state.isHeaderPriceVisible && this.props.isSummary ?
                        <div>
                            {this.state.quote.premiums.annual.formatted.gross_inc_ipt_and_fee ?
                                <div className="header-prices">
                                    <div className="single">
                                        Single <span className="hidden-xs">Payment</span> <span className="price single-price">£<span className="price-value">{this.state.quote.premiums.annual.formatted.gross_inc_ipt_and_fee}</span></span>
                                    </div>

                                    <div className="monthly">
                                        Monthly <span className="hidden-xs">Payment</span> <span className="price monthly-price">£<span className="price-value">{this.state.quote.premiums.monthly.formatted.gross_inc_ipt_and_fee}</span></span>
                                    </div>
                                </div>
                            : null}
                        </div>
                    :
                        <div className="header-contact">
                            <div className="call">
                                <span className="primary-colour">Call us on</span><br />
                                <span className="phone-number">0800 038 4574</span>
                            </div>
                            <div className="open-hours hidden-sm-down">
                                <span className="pull-left">Weekdays</span>
                                <span className="pull-right">8:30am - 5:30pm</span>
                                <div className="clearfix" />
                                <span className="pull-left">Saturday</span>
                                <span className="pull-right">9:30am - 1:00pm</span>
                            </div>
                        </div>
                    }
                    <div className="clearfix" />
                </div>
            </header>
        );
    }
});

export default GlobalHeader;



/** WEBPACK FOOTER **
 ** ./src/components/Fragments/GlobalHeader.js
 **/